import { render, staticRenderFns } from "./MediaLibraryCard.vue?vue&type=template&id=a34c633c&scoped=true&"
import script from "./MediaLibraryCard.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryCard.vue?vue&type=script&lang=js&"
import style0 from "./MediaLibraryCard.vue?vue&type=style&index=0&id=a34c633c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34c633c",
  null
  
)

export default component.exports